  /**
   * Addons Form Components
   *
   */
  class AddonsForm extends HTMLElement {
      constructor() {
      super(); 
          this.form = this
            this.toggleCustomEmbriodery();

           }

        toggleCustomEmbriodery(){
            let addOnItemsEle = this.querySelectorAll('[data-addon-selection]');
            addOnItemsEle.forEach( ele => {
                ele.addEventListener('change' , event => {


                    let selectedAddonEle = this.querySelectorAll('.addon-products [data-addon-selection]:checked');
                    let addonFormEle = ele.closest('.custom-control');
                    if(ele.checked){
                        ele.closest('.addon-products').classList.add('selected-addon');
    
                        let priceEle = addonFormEle.querySelector('[data-addons-currentPrice]');
                        let addonPrice = parseInt(priceEle.getAttribute('data-price'));
                        let productPrice = document.querySelector('[data-mainProPrice]').getAttribute('data-mainProPrice');
                         let totalPrice = parseInt(addonPrice) + parseInt(productPrice);

                         document.querySelector('[data-mainProPrice]').innerHTML =  Shopify.formatMoney(totalPrice*100, window.globalVariables.money_format); 
                         document.querySelector('[data-mainProPrice]').setAttribute('data-mainProPrice',`${totalPrice}`)

                        let isCustomembro = ele.getAttribute('data-custom_embiodery');
                        isCustomembro == 'true' ?  this.querySelector('[data-customOptions]').classList.remove('d-none') : ''
                       
                        document.querySelector('[data-noupgrades]').classList.remove('selected-addon');
                        document.querySelector('[data-noupgrades] input').removeAttribute('checked' , true);

                    }
                    else{
                        let priceEle = addonFormEle.querySelector('[data-addons-currentPrice]');
                        let addonPrice = parseInt(priceEle.getAttribute('data-price'));
                         
                        let productPrice = document.querySelector('[data-mainProPrice]').getAttribute('data-mainProPrice');
                         let totalPrice = parseInt(productPrice) - parseInt(addonPrice);
                        
                         document.querySelector('[data-mainProPrice]').innerHTML =  Shopify.formatMoney(totalPrice*100, window.globalVariables.money_format); 
                         document.querySelector('[data-mainProPrice]').setAttribute('data-mainProPrice',`${totalPrice}`)

                        this.querySelector('[data-customOptions]').classList.add('d-none');
                        ele.closest('.addon-products').classList.remove('selected-addon');
                    }
                })
            })
        }

  }

  customElements.define('addons-form', AddonsForm);

  class AddonsVariantSelects extends HTMLElement {
      constructor() {
      super();
          this.form = this.closest('addons-form');
          if(this.form.querySelector('[data-addon-selection]'))
          this.addOnSelection = this.form.querySelector('[data-addon-selection]');

          this.variant_json = this.form.querySelector('[data-addons-variantJSON]');
          this.variantPicker = this.dataset.type;
          this.addEventListener('change', this.onVariantChange.bind(this));
      }

      onVariantChange() {
          this.setCurrentVariant();
          if (!this.currentVariant) {
              this.toggleAddButton('disable');
              let options = this.form.querySelectorAll('[data-addons-optionindex]');
              options.forEach(option => {
                  let lableID = 'option'+option.dataset.optionindex;
                  const selectedValue = option.querySelector('input[type="radio"]:checked');
                  const lable = option.querySelector('.selected-option');
                  if(!lable || !lableID || !selectedValue) return;
                  lable.innerHTML = selectedValue.value;
              });
          }else{
              const productGrid = this.closest('[data-product-grid]');
              let varPrice = this.currentVariant.price / 100;
              let currentTarget = event.currentTarget;
              let addonform = currentTarget.closest('addons-form')
              addonform.querySelector('[data-addons-currentPrice]').setAttribute('data-price' , varPrice)
              this.renderProductInfo(this.currentVariant, productGrid);
              this.updateID(this.currentVariant);
              this.toggleAddButton('enable');
          }
          
          let addOnItemsEle = document.querySelectorAll('[data-addon-selection]');
          addOnItemsEle.forEach( ele => {
              if(ele.checked){
                  let addonFormEle = ele.closest('.custom-control');
                      let priceEle = addonFormEle.querySelector('[data-addons-currentPrice]');
                      let addonPrice = parseInt(priceEle.getAttribute('data-price'));
                       
                      let productPrice = document.querySelector('[data-actualPrice]').getAttribute('data-actualPrice');
                       let totalPrice = parseInt(addonPrice) + parseInt(productPrice/100);
                      
                       document.querySelector('[data-mainProPrice]').innerHTML =  Shopify.formatMoney(totalPrice*100, window.globalVariables.money_format); 
                       document.querySelector('[data-mainProPrice]').setAttribute('data-mainProPrice',`${totalPrice}`)
                  }
          })
      }

      _getOptionsFromSelect() {
          let options = [];
          this.querySelectorAll('.addons-variant_selector').forEach((selector)=>{
              options.push(selector.value);
          });
          return options;
      }

      _getOptionsFromRadio() {
          const fieldsets = Array.from(this.querySelectorAll('fieldset'));
          const options = fieldsets.map((fieldset) => {
              return Array.from(fieldset.querySelectorAll('input[type="radio"]')).find((radio) => radio.checked).getAttribute('data-value');
          });
          return options;
      }

      setCurrentVariant() {
          this.currentVariant = false;
          let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();
          let variantsArray = this._getVariantData();
          variantsArray.find((variant) => {
              let mappedValues = variant.options.map((option, index) => {
                  return options[index] == option;
              });
              if(!mappedValues.includes(false)){
                  this.currentVariant = variant;
                  return;
              }
          });
      }

      updateID(currentVariant) {
          if (!currentVariant) return;
          const input = this.form.querySelector('input.variant--id');
          input.value = currentVariant.id;
      }

      renderProductInfo(currentVariant, container) {
          if(!currentVariant || !container) return;

          // Price Update
          let price = Shopify.formatMoney(currentVariant.price, window.globalVariables.money_format);
          let priceElement = container.querySelector('[data-addons-currentPrice]');
          if(priceElement) priceElement.innerHTML = price;

          // Variant name update
          let options = this.form.querySelectorAll('[data-addons-optionindex]');
          options.forEach(option => {
              let lableID = 'option'+option.getAttribute('data-addons-optionindex');
              const lable = option.querySelector('.selected-option');
              if(!lable || !lableID) return;
              lable.innerHTML = currentVariant[lableID];
          });

          if(!currentVariant.featured_image) return;
          const featuredImage = container.querySelector('[data-addons-feauredImage]');
          let updatedSrc = currentVariant.featured_image.src;
          if(updatedSrc && featuredImage){
              featuredImage.src = updatedSrc;
              featuredImage.srcset = updatedSrc;
          }
      }

      toggleAddButton(status) {
          if (status == 'disable' || (this.currentVariant && !this.currentVariant.available)) {
              this.addOnSelection.disabled = true;
          }else{
              this.addOnSelection.disabled = false;
          };
      }

      _getVariantData() {
          this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);
          return this.variantData;
      }
  }
  customElements.define('addons-variant-selects', AddonsVariantSelects);

  class AddonsVariantRadios extends AddonsVariantSelects {
      constructor() {
      super();
          this.form = this.closest('addons-form');
          const colorSwatchContainer = this.querySelector('.color-swatch');
          if(colorSwatchContainer){
              const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
              colorSwatches.forEach(swatch => {
                  let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
                  let swatchStyle = Utility.getSwatchStyle(colorHandle);
                  swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
              });
          }
      }
  }
  customElements.define('addons-variant-radios', AddonsVariantRadios);